import { AdaptiveDate } from "./AdaptiveDate";
import { RecordStatusBadge } from "../RecordStatusBadge";
import type { RecordStatusProps } from "../types/recordHeader.types";

export const RecordStatus = ({ status, date, className = "" }: RecordStatusProps) => {
  return (
    <div className={`flex flex-col items-end gap-2 ${className}`}>
      <RecordStatusBadge status={status} />
      {date && <AdaptiveDate date={date} />}
    </div>
  );
};